import { ColDef } from "ag-grid-community";
import { CareGap, exampleCareGaps } from "./shared";

export type CareGapRowData = {
  id: string;
  name: string;
  description: string;
  code: string;
};

/**
 * The whole Table for only for demo purposes
 */
export const careGapTableData = () => {
  const columnDefs: ColDef<CareGapRowData>[] = [
    { field: "id", hide: true },
    { field: "name", flex: 2 },
    { field: "code", flex: 1, headerName: "CPT-II Code" },
    { field: "description", flex: 3 },
  ];

  return {
    columnDefs,
    rowData: getCareGapRowData(getCareGapsAndRelatedResources()),
  };
};

function getCareGapsAndRelatedResources(): CareGap[] {
  return exampleCareGaps;
}

function getCareGapRowData(careGaps: CareGap[]): CareGapRowData[] {
  return careGaps?.flatMap(careGap => {
    return {
      id: careGap.id,
      name: careGap.name,
      description: careGap.description,
      code: careGap.code,
    };
  });
}
